// extracted by mini-css-extract-plugin
module.exports = {"PurchaseOutlineLabel":"PurchaseOutlineLabel_PurchaseOutlineLabel__2l-HM"};